import Vue from "vue";
import Vuex from "vuex";

//挂载Vuex
Vue.use(Vuex);

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      // 判断这个cookie的参数名是不是我们想要的
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
let info = JSON.parse(getCookie("userinfo"));
console.log(info);
if (!info) {
  info = {
    username: "",
    uuid: ""
  };
}
//创建VueX对象
const store = new Vuex.Store({
  state: {
    //存放的键值对就是所要管理的状态
    name: info.username ? info.username : "",
    uuid: info.uuid ? info.uuid : ""
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js